import { Action, initialState, State } from "store/store";

export const setExitComplete = (state: State = initialState, { data }: Action) => {
  return {
    ...state,
    exitComplete: data
  };
};